import { Component, Input } from "@angular/core"
import { ModalController } from "ionic-angular"

import { EventDetailPage } from "../../pages/events/detail"

@Component({
  selector: "event-card",
  templateUrl: "index.html",
})
export class EventCard {

  @Input() event: any = {}

  constructor(
    private modalCtrl: ModalController
  ) {}

  onShowDetail(event) {

    this.modalCtrl.create(EventDetailPage, { event }).present()
  }
}



// WEBPACK FOOTER //
// ./src/components/event-card/index.ts